import "date-fns";
import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Table from "components/Table/Table";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "components/CustomButtons/Button.js";
import Grid from '@material-ui/core/Grid';
import { getOrdersbyStatus } from "../../services/orders/orders";
import { getSlots } from "../../services/slots/slots";
import Chart from "components/Chart/ChartPermanencyRate";
import CircularProgress from "../Circular/Circular";
import ExportCsv from "exportCsv.js";
import MomentUtils from "@date-io/date-fns";
import pt from "date-fns/locale/pt";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker
} from '@material-ui/pickers';

import '../Slots/style.css';

const useStyles = (theme) => ({
  iconView: {
    color: "gray !important",
  },
  root: {
    "& .MuiFormControl-root": {
      margin: theme.spacing(1),
      width: 200,
    },
  },
  dialog: {
    "& .MuiPaper-root": {
      margin: theme.spacing(1),
      width: 250,
      height: 200,
    },
  },
  green: {
    "& label.Mui-focused": {
      color: "green",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "green",
    },
  },
  red: {
    "& label.Mui-focused": {
      color: "red",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "red",
    },
  },
});

class PermanencyRate extends Component {
  constructor(props) {
    super(props);
    this.getOrders = this.getOrders.bind(this);
    this.handleExport = this.handleExport.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.getDiff = this.getDiff.bind(this);
    this.handleDateChangeInit = this.handleDateChangeInit.bind(this);
    this.handleDateChangeFinal = this.handleDateChangeFinal.bind(this);

    this.state = {
      selectedDate: new Date(),
      hours: [
        {
          value: 1,
          label: "1h",
        },
        {
          value: 2,
          label: "2h",
        },
        {
          value: 3,
          label: "3h",
        },
        {
          value: 4,
          label: "4h",
        }

      ],
      hour: 1,
      data: [],
      circular: true,
      dataExport: [],
      months: [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro"
      ],
      selectedDateInital: new Date().setDate(new Date().getDate() - 30),
      selectedDateFinal: new Date(),
      period: [0, 1, 12, 24, 36, 48, 60, 72],
      chartData: [],
    };
  }

  componentDidMount() {
    this.getOrders();
  }

  handleDateChange(selectedDate) {
    this.setState({ selectedDate });
  }

  handleExport = () => {
    const { dataExport } = this.state;
    ExportCsv(dataExport);
  };

  handleSearch = () => {
    let selectedDate = (this.state.selectedDate) ? new Date(this.state.selectedDate) : new Date();
    this.setState({ circular: true });
    this.getOrders(selectedDate.getFullYear(), (selectedDate.getMonth()));
  };

  handleDateChangeInit(selectedDateInital) {
    this.setState({ selectedDateInital });
  }

  handleDateChangeFinal(selectedDateFinal) {
    this.setState({ selectedDateFinal });
  }

  getOrders = (year = (new Date()).getFullYear(), month = ((new Date()).getMonth())) => {
    let data = [];
    let dataExport = [];
    let chartData = [];
    const { months, hour, selectedDateFinal, selectedDateInital, period } = this.state;
    getSlots(this.props.lockerId, (slots) => {
      let capacitySlots = (slots.length) ? slots.length - 1 : 0;
      getOrdersbyStatus(this.props.lockerId, 'collected&status=courrier_collected', (order) => {

        order = order.filter(o => o.collectedAt ? selectedDateInital <= new Date(o.collectedAt).getTime() && new Date(o.collectedAt).getTime() <= selectedDateFinal : false);
        let ordersQty = order.length;
        let ordersCount = 0;
        let orderDiff = [];

        if (ordersQty > 0) {

          order.forEach((o, index) => {

            orderDiff.push(this.getDiff(o));

          });

          for (let i = 1; i < period.length; i++) {

            if (i == 1) {
              ordersCount = orderDiff.filter(o => o <= 1).length;
            } else if ((period.length - 1) == i) {
              ordersCount = orderDiff.filter(o => o >= period[i]).length;
            } else {
              ordersCount = orderDiff.filter(o => o <= period[i] && o > period[i - 1]).length;
            }

            let rate = Number(((ordersCount / order.length) * 100).toFixed(2));

            data.push([`${period[i]}`, `${rate}%`]);
            dataExport.push({ 'Permanência (horas)': `${period[i]}`, 'Taxa de permanência': `${rate}%` });
            chartData.push({ year: `${period[i]}`, max: rate });
          }
        } else {
          data.push(["Nenhuma encomenda retirada nesse período!"]);
          dataExport.push({ 'Permanência (horas)': `-`, 'Taxa de permanência': `-%` });
        }

        this.setState({ circular: false, data, dataExport, chartData });
      });
    });
  }

  getDiff = (order) => {

    let diff = (Math.abs(new Date(order.collectedAt).getTime() - new Date(order.allocatedAt).getTime()) / 3600000).toFixed(2);
    diff = Number(String(diff).split('.')[0]);

    return diff;

  }

  render() {
    const { classes } = this.props;
    const { selectedDateInital, selectedDateFinal, chartData, data, circular } = this.state;

    let layout = (circular) ?
      <div className={classes.root}>
        <CircularProgress />
      </div>
      : <div>
        <h5>TAXA DE PERMANÊNCIA</h5>
        <div className="occupancy-top">
          <MuiPickersUtilsProvider utils={MomentUtils} locale={pt}>
            <Grid container justify="space-around">
              <KeyboardDatePicker
                locale="pt"
                variant="inline"
                format="dd/MM/yyyy"
                label="Data Inicial"
                value={selectedDateInital}
                onChange={this.handleDateChangeInit}
              />
            </Grid>
          </MuiPickersUtilsProvider>
          <MuiPickersUtilsProvider utils={MomentUtils} locale={pt}>
            <Grid container justify="space-around">
              <KeyboardDatePicker
                locale="pt"
                variant="inline"
                format="dd/MM/yyyy"
                label="Data Final"
                value={selectedDateFinal}
                onChange={this.handleDateChangeFinal}
              />
            </Grid>
          </MuiPickersUtilsProvider>
          <div></div>
          <Button onClick={this.handleSearch} color="primary">
            Pesquisar
            </Button>
          <Button onClick={this.handleExport} color="default">
            Exportar
            </Button>
        </div>
        <div className="occupancy-down">
          <Table
            tableHeaderColor="primary"
            tableHead={["Permanência (horas)", "Taxa de permanência"]}
            tableData={data}

          />
          <div className="char-area">
            <Chart info={chartData} />
          </div>
        </div>
      </div>;

    return (
      <div>
        {layout}
      </div>
    );
  }
}
export default withStyles(useStyles)(PermanencyRate);
